import { useRef, useState } from "react";
import { EmptyDesignation, IEmptyDesignation, Table } from "./Table";
import { Form } from "./Form";
import { IPermissionProps } from "../../models/Login";
import { Toast } from "primereact/toast";

export interface IModal{
    singleData: IEmptyDesignation,
    open: boolean  
}

export const Designation = (permissions: IPermissionProps) => {
    const [modal,setModal] = useState({singleData: {}, open: false} as IModal);
    const [reload, setReload] = useState(false);
    const toast = useRef<any>(null);

    const hideDialog = () => {
        setModal({ singleData: EmptyDesignation, open: false});
    };

    return (
        <>
            {(permissions.is_Create || permissions.is_Update) && <Form singleData={modal.singleData} open={modal.open} hideDialog={hideDialog} toast={toast} reload={reload} setReload={setReload}></Form>}
            <Table permissions={permissions} setModal={setModal} toast={toast} reload={reload} setReload={setReload}></Table>
            <Toast ref={toast} />
        </>
    );
}